import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { withModalActions, withImagesData } from 'core/hocs';
import { FormattedTag, RouteLink } from 'core/components';

import { withPixelRatio } from 'hocs/with-pixel-ratio';
import { ModalWindow } from 'components/modal-window/modal-window';

import { getImageUrlWithRatio } from 'helpers/images';
import { createBasicPath } from 'helpers/check-pixel-ratio';

import { IMAGES_DATA_CATEGORIES, MODAL_IDS } from '../../../constants';

import 'src/components/modals/promo-info-modal/promo-info-modal.scss';

const { LOGGED_IN_MODAL_BANNER } = IMAGES_DATA_CATEGORIES;

class PromoModalUI extends Component {
  static propTypes = {
    closeModal: PropTypes.func.isRequired,
    pixelRatio: PropTypes.string.isRequired,
    imagesData: PropTypes.shape().isRequired,
  };

  onButtonClick = () => {
    const { closeModal } = this.props;

    closeModal(MODAL_IDS.PROMO_INFO);
  }

  render() {
    const { pixelRatio, imagesData } = this.props;

    const imgList = imagesData[LOGGED_IN_MODAL_BANNER];
    const modalBanner = imgList ? imgList[imgList.length - 1] : {};
    const imgBasicPath = createBasicPath(modalBanner?.imgUrl) || [];
    const imgUrlWithPixelRatio = getImageUrlWithRatio(imgBasicPath, pixelRatio);

    return (
      <ModalWindow
        id={MODAL_IDS.PROMO_INFO}
        coreProps={{ id: MODAL_IDS.PROMO_INFO }}
        bodyClassName="d-flex d-sm-block align-items-center flex-column justify-content-sm-center text-center bg-gray-blue"
        className="promo-info-modal"
        isCentered
        fade
      >
        <div className="d-flex justify-content-center">
          <img className="w-100 d-none d-sm-block promo-info-modal-image" src={imgUrlWithPixelRatio} alt="promo-info" />
        </div>

        <FormattedTag
          tag="div"
          id="promo-info-modal.title"
          className="h5 mb-1_25 mt-2 promo-info-modal-title"
        />
        <FormattedTag
          tag="div"
          id="promo-info-modal.description"
          className="mb-1_5 mx-auto promo-info-modal-description"
        />
        <div className="mt-3_5 w-100">
          <FormattedTag
            id="promo-info-modal.button"
            tag={RouteLink}
            type="primary"
            to="/promos"
            className="w-100 btn btn-primary btn-lg"
            onClick={this.onButtonClick}
          />
        </div>
      </ModalWindow>
    );
  }
}

export const PromoInfoModal = withImagesData(withModalActions(withPixelRatio(PromoModalUI)));
